import { Accordion, AccordionDetails, AccordionSummary, Button, Checkbox, CircularProgress, ListItemText, makeStyles, MenuItem, TextField, Typography } from "@material-ui/core";
import { CheckBox } from "@material-ui/icons";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAllRoutes, handleRoutesUpdate } from "../../actions/sortingMachineManagementActions";
import { getOpenCreateEditSortingMachineDialog } from "../../reducers/uiSlice";
import FullscreenLoading from '../Common/FullscreenLoading';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& .MuiAccordionSummary-root': {
            padding: '0px !important',
            border: '1px solid #3a3a3a'
        },
        '& .MuiAccordionDetails-root': {
            padding: '0px !important'
        }
    },
    titleStyle: {
        display: 'flex',
        justifyContent: 'space-between',
        color: '#707070',
        alignItems: 'center'
    },
    accordionSummary: {
        backgroundColor: 'rgb(58, 58, 58)',
        border: 'none !important',
        boxShadow: 'none !important',
        padding: '0 !important',
        textAlign: 'left'
    }
}))

function AllRoutes(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation('sortingMachineManagement');

    const sortingWarehouses = useSelector(state => state.smmReducer.sortingWarehouses);
    const loading = useSelector(state => state.smmReducer.allRoutesLoading);
    const routesUpdate = useSelector(state => state.smmReducer.routesUpdate);
    const dialogObj = useSelector(getOpenCreateEditSortingMachineDialog);

    const [warehouse, setWarehouse] = useState();
    const [expanded, setExpanded] = useState();

    const handleAccordionChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    }

    const handleChecked = (index, i, type) => {
        let clone = [...routesUpdate];
        if (type === 'single') {
            let checked = routesUpdate[index].routes[i].checked || false;
            clone[index].routes[i].checked = !checked;
            if (!checked) {
                clone[index].allChecked = false;
            }
        } else {
            let checked = routesUpdate[index].allChecked || false;
            clone[index].allChecked = !checked;
            clone[index].routes.map((ele) => {
                if (!ele.inserted) {
                    ele.checked = !checked;
                }
            })
        }
        dispatch(handleRoutesUpdate(clone))
    }

    const handleAssignStatusToRoutes = (clone, route, i) => {
        clone.map((district) => {
            const length = district?.routes.length;
            district?.routes.map((routeObj) => {
                let idMatched = route.route_id + '' === routeObj.route_id + '';
                routeObj.checked = idMatched || routeObj.checked;
                routeObj.inserted = routeObj.checked;
                if (idMatched && (++i === length)) {
                    district.allChecked = true;
                    district.allInserted = true;
                }
            })
        })
        return i;
    }

    const handleWarehouseSwitchRoutes = (districts) => {
        let clone = [...districts];
        if (props.totalGrids?.length > 0 && clone?.length > 0) {
            props.totalGrids.filter((grid) => {
                if (grid?.routes?.length > 0) {
                    let i = 0;
                    grid?.routes.filter((route) => {
                        i = handleAssignStatusToRoutes(clone, route, i);
                    })
                }
            })
        }
        dispatch(handleRoutesUpdate(clone))
    }

    useEffect(() => {
        if (warehouse) {
            props.handleWarehouse(warehouse);
            dispatch(getAllRoutes(warehouse))
                .then((res) => {
                    if (res[0]?.districts) {
                        handleWarehouseSwitchRoutes(res[0].districts);
                    }
                })
                .catch(() => {
                    handleWarehouseSwitchRoutes([]);
                })
        }
    }, [warehouse])

    useEffect(() => {
        if (dialogObj.open) {
            dispatch(handleRoutesUpdate([]));
            setWarehouse();
        }
    }, [dialogObj.open])

    return (
        <div className={classes.root}>
            <div className={classes.titleStyle}>
                <div>{t('routes_zones')}</div>
                <div
                    style={{ color: '#FF9D00', cursor: 'pointer' }}
                    onClick={props.handleInsert}
                >
                    {t('insert')}
                </div>
            </div>
            <div style={{ marginTop: 20 }}>
                <TextField
                    select
                    variant="outlined"
                    value={warehouse}
                    label={t('warehouse')}
                    onChange={(e) => setWarehouse(e.target.value)}
                    fullWidth
                >
                    {
                        sortingWarehouses?.length > 0 &&
                        sortingWarehouses.map((sortingWarehouse) => (
                            <MenuItem value={sortingWarehouse.id}>{sortingWarehouse.name}</MenuItem>
                        ))
                    }
                </TextField>
            </div>
            <div style={{ textAlign: 'center', marginTop: 20 }}>
                {
                    !loading &&
                    <div>
                        {
                            routesUpdate?.length > 0 &&
                            routesUpdate.map((route, index) => (
                                <Accordion
                                    expanded={expanded === route.district_id}
                                    onChange={handleAccordionChange(route.district_id)}
                                    className={classes.accordionSummary}
                                >
                                    <AccordionSummary>
                                        {route.district_name}
                                    </AccordionSummary>
                                    <AccordionDetails
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column'
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center'
                                            }}
                                        >
                                            <Checkbox
                                                color="secondary"
                                                onClick={() => handleChecked(index)}
                                                checked={route.allChecked === true}
                                                disabled={route.allInserted}
                                            />
                                            <span>{t('select_all')}</span>
                                        </div>
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column'
                                            }}
                                        >
                                            {
                                                route?.routes?.length > 0 &&
                                                route.routes.map((ele, i) => (
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center'
                                                        }}
                                                    >
                                                        <Checkbox
                                                            color="secondary"
                                                            onClick={() => handleChecked(index, i, 'single')}
                                                            checked={ele.checked === true}
                                                            disabled={ele.inserted}
                                                        />
                                                        <span>{ele.route_name}</span>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            ))
                        }
                    </div>
                }
            </div>
            <FullscreenLoading open={loading} />
        </div>
    );
}
export default AllRoutes;